<template>
  <div id="app">
    <!-- 加载 -->
    <div class="preloader"></div>
    <header id="header">
    	<div class="site-header header-style-1 site-one">
    		<nav class="navigation navbar navbar-default">
    			<div class="container-fluid">
    				<div class="navbar-header">
    					<button type="button" @click="openMenu" class="open-btn">
    						<span class="sr-only">Toggle navigation</span>
    						<span class="icon-bar"></span>
    						<span class="icon-bar"></span>
    						<span class="icon-bar"></span>
    					</button>
    					<a class="navbar-brand" href="javascript:void(0);">
    						<img src="./assets/images/logo/logo.png" @click="goBack" />
    					</a>
    				</div>
    				<div id="navbar" class="navbar-collapse collapse navigation-holder" :class="{'show-menu': showMenu}">
    					<button class="close-navbar" @click="closeMenu"><i class="el-icon-close"></i></button>
    					<div class="navTop">
    						<ul class="searchNav">
    							<li class="searchName searchNameTwo">
    								<span><img src="./assets/images/home/add.png" height="20" width="20"/></span>
    								<span class="aboutName" @click="goMap">网站地图</span>
    							</li>
    							<li class="searchName searchNameTwo">
    								<span><img src="./assets/images/home/wachet.png" height="21" width="21"/></span>
    								<span class="aboutName" @mouseenter="enter" @mouseleave="leave">微信公众号</span>
                    <span class="bercode" v-show="seen">
                      <img src="./assets/images/home/erwei.png"/>
                    </span>
    							</li>
    							<!-- <li class="searchName searchNameTwo" @mouseenter="enterSearch($event)" @mouseleave="leaveSearchOne($event)">
                    <span><img src="./assets/images/Search.png" height="20" width="20"/></span>
                     <span class="aboutName">查找</span> 
                    <div class="headSearch" v-show="searchSeen" @mouseleave="leaveSearch">
                      <el-input placeholder="请输入内容" v-model="input2" clearable>
                        <template slot="append"><i class="el-icon-search" @click="Search"></i></template>
                      </el-input>
                    </div>

    							</li> -->
    						</ul>
    					</div>
    					<ul class="nav navbar-nav">
    						<li v-for="item in menuList" >
    							<a class="firstNva" @click="changeRouterFirst(item)">{{item.Name}}</a>
    							<ul class="sub-menu" v-if="item.subMenu.length > 0 && !showMenu">
    								<li v-for="(items,index) in item.subMenu" @click="changeRouter(item, items)" :key="index"><a>{{items.Name}}</a></li>
    							</ul>
    						</li>
    					</ul>
    				</div>

    			</div>
    		</nav>
    	</div>
    </header>
    <router-view/>
    <!--友情链接-->
    <section class="Room-area section-padding">
    	<div class="Room-section">
    		<div class="sub-container">
    			<div class="warp">
    				<div class="roomLeft">友情链接</div>
    				<div class="roomRight">
    					<div class="col col-xs-12 sortable-gallery">
    						<ul class="gallery-container gallery-fancybox masonry-gallery">
                  <li :class="num===index?'activeTop grid':'grid'"  v-for="(items , index) in linksGroup" :key="index" @mouseenter="enters(index)" @mouseleave="leaver(index)">
                    <div class="firdTitle">{{items.Name}}</div>
                    <div class="newShow">
                      <div class="newShowTitle">{{items.Name}}</div>
                      <div class="row rowShow">
                        <p class="showContent" v-for="(childitems,childIndex) in items.children" :key="childIndex">
                          <a :href="childitems.Url" target="_blank">{{childitems.Name}}</a>
                        </p>
                      </div>
                    </div>
                  </li>
    						</ul>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    	<div class="Room-sectionTwo">
    		<ul class="gallery-container gallery-fancybox masonry-gallery">
    			<li class="grid">
    				<div class="firdTitle" @click="goLink()">友情链接</div>
    			</li>
    			<li class="grid">
    				<div class="firdTitle" @click="goMap()">网站地图</div>
    			</li>
    			<li class="grid">
    				<div class="firdTitle" @click="goContact()">联系我们</div>
    			</li>
    		</ul>
    	</div>
    </section>
    <!--底部-->
    <footer class="wpo-site-footer">
    	<div class="wpo-lower-footer">
    		<div class="sub-container">
    			<div class="row">
    				<div class="col col-md-4 col-sm-3">
    					<div class="term">
    						<div class="foCompany">
    							<img src="./assets/images/home/company.png"/>
    						</div>
    						<div class="footTel">
    							<div class="footTel-email" @mouseenter="entEmail" @mouseleave="leaEmail">
                    <img src="./assets/images/home/tel.png"/>
                    <div class="Email" v-show="EmailSeen">
                      <ul>
                        <li>
                          <!-- 网上信访:JLFDJTXF@163.com -->
                          <a href="#">网上信访:JLFDJTXF@163.com</a>
                        </li>
                        <li>
                          <!-- 纪检邮箱:JLFDJTXF@163.com -->
                          <a href="#">纪检邮箱:JLFDJTXF@163.com</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="footTel-contact">
                    <img src="./assets/images/home/contact.png"/>
                  </div>
    						</div>
    					</div>
    				</div>
    				<div class="col col-md-7 col-sm-8">
    					<div class="term">
    						<ul class="termOne">
    							<li>©1983-2023 版权所有 南京金陵饭店集团有限公司</li>
    							<li>|</li>
    							<li><a href="http://beian.miit.gov.cn" target="_blank">苏ICP备2023050988号</a></li>
    						</ul>

    						<ul class="termOne">
    							<li>地址：中国江苏省南京市鼓楼区大锏银巷17号艺术金陵产业园博萃楼</li>
    							<li>|</li>
    							<li>邮编：210017</li>
    						</ul>
    						<ul class="termOne">
    							<li>传真：86-25-84702881</li>
    							<li>|</li>
    							<li>网站技术支持：江苏虚拟软件园股份有限公司</li>
    						</ul>
    					</div>
    				</div>
    				<div class="col col-md-1 col-sm-1 wchatImg">
    					<img src="./assets/images/home/erwei.png"/>
    					<p>微信公众号</p>
    				</div>
    			</div>
    		</div>
    	</div>
    	<div class="wpo-lower-footerTwo">
    		<div class="mbofootTop">
    			<img src="./assets/images/home/mobel.jpg"/>
    		</div>
    		<div class="mbofootContent">
    			<span>©1983-2023 版权所有 南京金陵饭店集团有限公司</span>
    			<span><a href="http://beian.miit.gov.cn" target="_blank">苏ICP备2023050988号</a></span>
    		</div>
    	</div>
    </footer>
  </div>
</template>

<script>
import * as api from './api/api.js'
import * as utils from './utils.js'
export default {
  name: 'App',
  data () {
    return {
      input2: '',
      showMenu: false,
      menuList: [{
        subMenu: []
      }],
      allList: [],
      listItem: {
        subMenu: []
      },
      parameter:'',// 参数
      linksGroup:[{
        children: []
      }],
      num: -1,
      seen:false,
      EmailSeen:false,
      searchSeen:false
    }
  },
  created () {
    this.getMenu()
    this.getLinks()
  },
  methods: {
    //二维码
    enter(){
      this.seen = true
    },
    leave(){
      this.seen = false
    },
    //举报信箱
    entEmail(){
      this.EmailSeen = true
    },
    leaEmail(){
      this.EmailSeen = false
    },
    // 查询
    enterSearch($event){
      $event.currentTarget.className="searchName searchNameTwo searchActive";
      this.searchSeen = true
    },
    leaveSearchOne($event){
      $event.currentTarget.className="searchName searchNameTwo";
    },
    leaveSearch(){
      this.searchSeen = false
    },
    Search(){
      if(window.location.hash.includes("Search")){
        this.$router.push({
          path:'/Search',
          query: {
            value: this.input2
          }
        })
      }else{
        this.$router.push({
          path:'/Search',
          query: {
            value: this.input2
          }
        })
      }

    },

    enters(index){
      this.num = index
      $(".newShow").eq(index).css({display:'block',height:"auto"});
      $(this).attr("class","activeTop grid");

      $(".firdTitle").eq(index).css({"color":"#111","backgroundColor":"#ececec"})
    },
    leaver(index){
      $(".newShow").css({display:'none',height:"auto"});
      $(".firdTitle").eq(index).css({"color":"white","backgroundColor":"rgba(34,34,34,1)"})
    },
    goBack:function () {
      var links = window.location.href.split('/#/')
      if(links[links.length -1].toString() === '' || links[links.length -1].toString() ===null || links[links.length -1].toString() ===undefined ){
        this.$message({message: '当前为首页',type: 'warning'})
      }else {
        this.$router.push({path: '/'})
      }
    },
    getMenu: function () {
      api.getMenu().then((res) => {
        if (res.Status === 100) {
          this.allList = res.Data.DataList
          res.Data.DataList.forEach((vv) => {
            if (vv.PCategoryId === -1) {
              vv.subMenu = []
              this.menuList.push(vv)
            }
          })
          this.menuList.forEach((vv) => {
            res.Data.DataList.forEach((ss) => {
              if (vv.Id === ss.PCategoryId && ss.Key !== 'siteMap') {
                vv.subMenu.push(ss)
              }
            })
            vv.subMenu.sort(function(a,b){
              return a.Order - b.Order;
            })
          })
          this.menuList.sort(function(a,b){
            return a.Order - b.Order;
          })
          utils.storage.set('jinLin_menu', this.menuList)
      }
      })
    },

    changeRouterFirst(item){
      if(item.Key === "jincaisource"){
        window.open('http://www.jinspurchase.com/',"_blank")
      }
      var links = window.location.href.split('/#/')
      if(item.subMenu.length === 0){
        if(links[links.length -1].toString() === '' || links[links.length -1].toString() ===null || links[links.length -1].toString() ===undefined ){
          this.$message({message: '当前为首页',type: 'warning'})
        }else {
          this.$router.push({path: '/'})
        }
      }else {
        var links = window.location.hash.split('/')
        if(links[links.length -1] !== item.subMenu[0].Key){
          if(item.subMenu[0].isList.toString()==='false'){
            this.$router.push({name: 'info', params:{fkey:item.Key,key: item.subMenu[0].Key}})
          }else {
            this.$router.push({name: 'news', params:{fkey:item.Key,key: item.subMenu[0].Key}})
          }
        }
      }
      if (this.showMenu) {
        this.closeMenu()
      }
    },

    changeRouter (item, items) {
      var links = window.location.hash.split('/')
      if(links[links.length -1] !== items.Key){
        if(items.isList.toString() !=='false'){
          this.$router.push({name: 'news', params:{fkey:item.Key,key: items.Key}})
        }else {
          if(items.Key ==='Postbox' || items.Key ==='Onlinepetition'){
            // const { href } = 'mailto:JLFDJTXF@163.com'
            // window.open('mailto:JLFDJTXF@163.com');
            // alert('over!');


            var gotolink = document.createElement('a');
            gotolink.href = '#';
            gotolink.setAttribute("target", "_blank");
            document.body.appendChild(gotolink);
            gotolink.click();

          }else if (items.Key ==='Onlineschool'){
            window.open('http://e-learning.jinlinghotels.com:8092',"_blank")
          }else {
            this.$router.push({name: 'info', params:{fkey:item.Key,key: items.Key}})
          }
        }
      }
      if (this.showMenu) {
        this.closeMenu()
      }
    },
    goMap () {
      this.allList.forEach((vv) => {
        if (vv.Key === 'siteMap') {
          let routeUrl = this.$router.resolve({
             name: "siteMap",
             params: {
               igid: vv.Id,
               key: vv.Key
             }
           });
           window.open(routeUrl.href, '_blank');
        }
      })
    },
    goContact () {
      let routeUrl = this.$router.resolve({
         name: "info",
         params: {
           fkey: 'ContentUs',
           key: 'contact'
         }
       });
       window.open(routeUrl.href, '_blank');
    },
    goLink () {
      let routeUrl = this.$router.resolve({
         name: "link"
       });
       window.open(routeUrl.href, '_blank');
    },
    // 获取友情链接
    getLinks(){
      api.LinkGroupModules().then(res =>{
        if(res.Status === 100){
          var Params = {
            Page: 1,
            PageSize: 200
          }
          api.LinkRefModules(Params).then(resTwo =>{
            if(resTwo.Status === 100){
              res.Data.DataList.forEach((vv)=>{
                vv.children =[]
                resTwo.Data.DataList.find((dd)=>{
                  if(dd.Ass_LinkGroup_Id === vv.Id){
                    vv.children.push(dd)
                  }
                  vv.children.sort(function(a,b){
                    return a.Order - b.Order;
                  })
                })
              })
              res.Data.DataList.sort(function(a,b){
                return a.Order - b.Order;
              })
              this.linksGroup = res.Data.DataList
              utils.storage.set('linksList',res.Data.DataList)
            }else {
              this.$message({message: '获取友情链接异常' ,type: 'warning'})
            }
          })

        }else {
          this.$message({message: '获取友情链接分组异常',type: 'warning'})
        }
      })

    },
    openMenu () {
      this.showMenu = true
    },
    closeMenu () {
      this.showMenu = false
    }
  }
}
</script>

<style>
@import url("assets/style.css");
@import url("assets/aboutus.css");
@import url("assets/NewsList.css");
@import url("./assets/global.css");
@import url("./assets/css/fit/phone.css");
@import url("assets/css/fit/pc.css");
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* filter: grayscale(1); */
}
a:hover, a:focus {
  text-decoration: none;
}
.show-menu{
  right: 0!important;
}
.navbar-nav {
  float: right!important;
  margin: 0;
  /* right: 0px; */
}
.ql-snow {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.ql-editor {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.footTel-email,.footTel-contact{
  display: inline-block;
  vertical-align: top;
}
.btn-prev span,.btn-next span,.my-btnF,.my-btnM{
  background-color: #BB9E51;
  border-radius: 5px;
  padding: 0px 15px;
  color: white;
}
.my-btnF,.my-btnM{
  font-size: 13px;
  min-width: 35.5px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
  display: inline-block;
  margin-top: 2px;
}
.my-btnF{
  margin-right: 10px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: black;
}
.el-pagination.is-background .el-pager li{
  background-color: white;
}
.bercode {
  position: absolute;
  z-index: 9;
  top: 50px;
  width: 125px;
  height: 125px;
  left: 10px;
}
.mainbg .el-carousel__item.is-active{
  z-index: 0;
}
.footTel .Email{
  position: absolute;
  left: 60px;
  bottom: -10px;
}
.footTel .Email ul{
  width: 250px;
  background: #ececec;
  font-size: 16px;
}
.footTel .Email ul li:nth-child(1){
  border-bottom: 1px solid #cccccc;
}
.footTel .Email ul li{
  width: 100%;
  text-align: center;
  line-height: 45px;
  cursor: pointer;
}
.footTel .Email ul li:hover a{
  color: #985f0d;
  display: block;
}
.site-one .searchName .headSearch{
  position: absolute;
  background-color: white;
  right: 15px;
  width: 350px;
  height: 40px;
  z-index: 99;
  margin-top: 20px;
}
.site-one .searchActive .aboutName{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue